import { isArrayValidAndNotEmpty } from '../constants/CommonUtil';
import { getStringFromObject } from '../constants/lodashUtils';
import { isObjectValidAndNotEmpty } from '../constants/nullCheckUtils';

export const getDrugDtoFromUiObject = (uiObject) => {
    let drug = {};
    if (isObjectValidAndNotEmpty(uiObject)) {
        drug = {
            name: getStringFromObject('drugName', uiObject, ''),
            localName: getStringFromObject('localName', uiObject, ''),
            code: getStringFromObject('code', uiObject),
            uom: getStringFromObject('productUom', uiObject) || null,
            uos: getStringFromObject('productUos', uiObject) || null,
            dosageForm: getStringFromObject('dosageForm', uiObject, {}),
            routes: getStringFromObject('drugRoutes', uiObject, {}),
            flags: getStringFromObject('drugClassification', uiObject) || null,
            drugInstruction: getStringFromObject('warnings', uiObject, {}),
            strength: getStringFromObject('strength', uiObject, ''),
            active: getStringFromObject('active', uiObject, false),
            defaultDose: getStringFromObject('defaultDose', uiObject, 0),
            defaultDoseUnit: getStringFromObject('defaultDoseUnit', uiObject, {}),
            defaultFrequency: getStringFromObject('defaultFrequency', uiObject, {}),
            defaultDuration: getStringFromObject('defaultDuration', uiObject, 0),
            defaultTotalQuantity: getStringFromObject('defaultTotalQty', uiObject, 0),
            defaultTotalQuantityUnit: getStringFromObject('defaultTotalQuantityUnit', uiObject, null),
            defaultDosageInstruction: getStringFromObject('defaultDosageInstruction', uiObject, null),
            allowedRefills: getStringFromObject('allowedRefills', uiObject, 0),
            combination: getStringFromObject('combination', uiObject, 0),
            listPrice: getStringFromObject('price', uiObject, 0),
            discount: getStringFromObject('discount', uiObject, 0),
            purchaseDiscount: getStringFromObject('purchaseDiscount', uiObject, 0),
            bonusPercentage: getStringFromObject('bonusPercentage', uiObject, 0),
            cost: getStringFromObject('cost', uiObject, 0),
            // genericDrug: getStringFromObject('genericDrug', uiObject, {}),
            uuid: getStringFromObject('uuid', uiObject, null),
            id: getStringFromObject('id', uiObject, null),
            leadTime: getStringFromObject('leadTime', uiObject, null),
            orderCycle: getStringFromObject('orderCycle', uiObject, null),
            bufferStock: getStringFromObject('bufferStock', uiObject, null),
            unitsInUom: getStringFromObject('unitsInUom', uiObject, null),
            insuranceState: getStringFromObject('insuranceState.key', uiObject, null) || null,
            exemptableFromTaxes: getStringFromObject('exemptableFromTaxes', uiObject, null) || false,
            genericDrugAttribute: getStringFromObject('genericDrugAttribute', uiObject, null),
            defaultForGenericAttribute: getStringFromObject('defaultForGenericAttribute', uiObject) || false,
            saleable: getStringFromObject('saleable', uiObject) || false,
            productGtinMapDtoList: getStringFromObject('productGtinMapDtoList', uiObject) || null,
            trackByBatchSerialNumber: getStringFromObject('trackByBatchSerialNumber', uiObject) || false,
            useBatchPrice: getStringFromObject('useBatchPrice', uiObject) || false,
            locRack: getStringFromObject('locRack', uiObject) || null,
        };
        const supplierUuid = getStringFromObject('supplier.uuid', uiObject);
        if (supplierUuid) {
            drug.supplier = {
                key: supplierUuid,
                value: getStringFromObject('supplier.name', uiObject),
            };
        }
        const taxes = getStringFromObject('taxes', uiObject, []);
        if (isArrayValidAndNotEmpty(taxes)) {
            drug.taxes = taxes.map(t => ({
                id: t.key,
                name: t.value,
            }));
        }
    }
    return drug;
};


export const drugInsuranceStates = {
    NEED_APPROVAL: 'Need Approval',
    COVERED: 'Covered',
    NOT_APPLICABLE: 'Not Applicable',
    REFERRED_OUT: 'Referred Out',
};


export const getUiObjectFromDto = (obj) => {
    let drug = {};
    if (isObjectValidAndNotEmpty(obj)) {
        drug = {
            drugName: getStringFromObject('name', obj, ''),
            code: getStringFromObject('code', obj),
            localName: getStringFromObject('localName', obj, ''),
            productUom: getStringFromObject('uom', obj, null),
            productUos: getStringFromObject('uos', obj, null),
            dosageForm: getStringFromObject('dosageForm', obj, {}),
            drugRoutes: getStringFromObject('routes', obj, {}),
            drugClassification: getStringFromObject('flags', obj) || null,
            warnings: getStringFromObject('drugInstruction', obj, {}),
            strength: getStringFromObject('strength', obj, ''),
            active: getStringFromObject('active', obj, false),
            defaultDose: getStringFromObject('defaultDose', obj, 0),
            defaultDoseUnit: getStringFromObject('defaultDoseUnit', obj, {}),
            defaultFrequency: getStringFromObject('defaultFrequency', obj, {}),
            defaultDuration: getStringFromObject('defaultDuration', obj, 0),
            defaultTotalQty: getStringFromObject('defaultTotalQuantity', obj, 0),
            defaultTotalQuantityUnit: getStringFromObject('defaultTotalQuantityUnit', obj, 0),
            defaultDosageInstruction: getStringFromObject('defaultDosageInstruction', obj, 0),
            allowedRefills: getStringFromObject('allowedRefills', obj, 0),
            combination: getStringFromObject('combination', obj, 0),
            price: getStringFromObject('listPrice', obj, 0),
            discount: getStringFromObject('discount', obj, 0),
            purchaseDiscount: getStringFromObject('purchaseDiscount', obj, 0),
            bonusPercentage: getStringFromObject('bonusPercentage', obj, 0),
            cost: getStringFromObject('cost', obj, 0),
            // genericDrug: getStringFromObject('genericDrug', obj, {}),
            uuid: getStringFromObject('uuid', obj, null),
            id: getStringFromObject('id', obj, null),

            leadTime: getStringFromObject('leadTime', obj, null),
            orderCycle: getStringFromObject('orderCycle', obj, null),
            bufferStock: getStringFromObject('bufferStock', obj, null),
            unitsInUom: getStringFromObject('unitsInUom', obj, null),
            exemptableFromTaxes: getStringFromObject('exemptableFromTaxes', obj, null) || false,
            genericDrugAttribute: getStringFromObject('genericDrugAttribute', obj, null),
            defaultForGenericAttribute: getStringFromObject('defaultForGenericAttribute', obj) || false,
            saleable: getStringFromObject('saleable', obj) || false,
            productGtinMapDtoList: getStringFromObject('productGtinMapDtoList', obj) || null,
            trackByBatchSerialNumber: getStringFromObject('trackByBatchSerialNumber', obj) || null,
            useBatchPrice: getStringFromObject('useBatchPrice', obj) || false,
            locRack: getStringFromObject('locRack', obj) || null,
        };
        const insuranceState = getStringFromObject('insuranceState', obj, null);
        if (insuranceState) {
            drug.insuranceState = {
                key: insuranceState,
                value: drugInsuranceStates[insuranceState],
            };
        }

        const supplierUuid = getStringFromObject('supplier.key', obj);
        if (supplierUuid) {
            drug.supplier = {
                uuid: supplierUuid,
                name: getStringFromObject('supplier.value', obj),
            };
        }
        const taxes = getStringFromObject('taxes', obj, []);
        if (isArrayValidAndNotEmpty(taxes)) {
            drug.taxes = taxes.map(t => ({
                key: t.id,
                value: t.name,
            }));
        }
    }
    return drug;
};

